import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import { renderRedirect } from "../util";
import {fetchSignApplication, updateSignApplication} from "./BasicProfile/api"
import { uploadKraDetails } from "./KYC/kraApi";
import Footer from "../Components/footer";

function extractAddressFields(addressStr) {
  if (!addressStr) {
    return { line: "", city: "", district: "", state: "", pin: "" };
  }
  let clean = decodeURIComponent(addressStr).replace(/[\r\n]+/g, " ").trim();
  let parts = clean.split(",").map(p => p.trim());
  
  let pinMatch = clean.match(/\b\d{6}\b/);
  let pin = pinMatch ? pinMatch[0] : "";
  
  if (parts.length > 0) {
    let last = parts[parts.length - 1];
    parts[parts.length - 1] = last.replace(pin, "").replace(/[-\s]+$/, "").trim();
  }
  
  let separate = parts.filter(p => p.length > 0);
  
  let state = separate[separate.length - 1] || "";
  let city = separate[separate.length - 2] || "";
  let district = city;
  
  let lineParts = separate.slice(0, Math.max(0, separate.length - 2));
  let line = lineParts.join(", ");
  
  if (separate.length === 1) {
    line = separate[0];
    state = "";
    district = "";
    city = "";
  } else if (separate.length === 2) {
    line = separate[0];
    state = separate[1];
    district = "";
    city = "";
  } else if (separate.length === 3) {
    line = separate[0];
    state = separate[2];
    district = separate[1];
    city = separate[1];
  }
  
  return { line, city, district, state, pin };
}

function serializeAddress(fields) {
  const parts = [];
  if (fields.line) parts.push(fields.line);
  if (fields.city) parts.push(fields.city);
  if (fields.district) parts.push(fields.district);
  if (fields.state) {
    if (fields.pin) {
      parts.push(`${fields.state} - ${fields.pin}`);
    } else {
      parts.push(fields.state);
    }
  } else if (fields.pin) {
    parts.push(fields.pin);
  }
  return parts.join(", ");
}

class AddressDetails extends Component {
  renderRedirect = () => {
    renderRedirect(this.props, "/additional");
  };
  constructor(props) {
    super(props);
    this.state = {
      residentialStatus: "",
      sameAddress: "yes",
      isValidated: false,
      
      perm_line: "",
      perm_city: "",
      perm_district: "",
      perm_state: "",
      perm_pin: "",
      
      comm_line: "",
      comm_city: "",
      comm_district: "",
      comm_state: "",
      comm_pin: "",
      
      errors: {
        residentialStatus: "",
      },
    };
  }
  
  validateForm = () => {
    const isPermValid = 
      this.state.perm_line && this.state.perm_line.trim() !== "" &&
      this.state.perm_city && this.state.perm_city.trim() !== "" &&
      this.state.perm_district && this.state.perm_district.trim() !== "" &&
      this.state.perm_state && this.state.perm_state.trim() !== "" &&
      this.state.perm_pin && this.state.perm_pin.trim() !== "";
      
    const isCommValid = this.state.sameAddress === "yes" || (
      this.state.comm_line && this.state.comm_line.trim() !== "" &&
      this.state.comm_city && this.state.comm_city.trim() !== "" &&
      this.state.comm_district && this.state.comm_district.trim() !== "" &&
      this.state.comm_state && this.state.comm_state.trim() !== "" &&
      this.state.comm_pin && this.state.comm_pin.trim() !== ""
    );

    if (this.state.residentialStatus && isPermValid && isCommValid) {
      this.setState({ ["isValidated"]: true });
      return true;
    } else {
      this.setState({ ["isValidated"]: false });
      return false;
    }
  };

  async componentDidMount() {
    let profileData = await fetchSignApplication();
    if(profileData && profileData.data && profileData.data.fetch_signup_application){
      let data = profileData.data.fetch_signup_application;
      
      const sameAddress = data.same_address || "yes";
      const permFields = extractAddressFields(data.permanentAddress);
      const commFields = sameAddress === "yes" ? permFields : extractAddressFields(data.communicationAddress);
      
      this.setState({
        residentialStatus: data.residentialStatus || "",
        sameAddress: sameAddress,
        
        perm_line: permFields.line,
        perm_city: permFields.city,
        perm_district: permFields.district,
        perm_state: permFields.state,
        perm_pin: permFields.pin,
        
        comm_line: commFields.line,
        comm_city: commFields.city,
        comm_district: commFields.district,
        comm_state: commFields.state,
        comm_pin: commFields.pin,
      });
    }
    window.setTimeout(function () {
      this.validateForm();
    }.bind(this), 600);
  }

  handleSameAddressChange = (event) => {
    const isChecked = event.target.checked;
    const sameAddress = isChecked ? "yes" : "no";
    
    if (isChecked) {
      this.setState({
        sameAddress,
        comm_line: this.state.perm_line,
        comm_city: this.state.perm_city,
        comm_district: this.state.perm_district,
        comm_state: this.state.perm_state,
        comm_pin: this.state.perm_pin,
      }, () => {
        this.validateForm();
      });
    } else {
      this.setState({ sameAddress }, () => {
        this.validateForm();
      });
    }
  };

  handleChange = (event) => {
    const { id, value } = event.target;
    let errors = { ...this.state.errors };
    
    const stateUpdate = { [id]: value };

    // Sync district with city
    if (id === "perm_city") stateUpdate.perm_district = value;
    if (id === "comm_city") stateUpdate.comm_district = value;
    
    this.setState(stateUpdate, () => {
      errors[id] = "";
      if (this.state.sameAddress === "yes") {
        if (id.startsWith("perm_")) {
          const commId = id.replace("perm_", "comm_");
          const update = { [commId]: value };
          // Also sync comm_district when perm_city changes
          if (id === "perm_city") update.comm_district = value;
          this.setState(update);
        }
      }
      this.setState({ errors });
      this.validateForm();
    });
  };

  handleSubmit = async(event) => {
    event.preventDefault();

    // Validate and show errors on empty required fields
    if (!this.validateForm()) {
      const errors = { ...this.state.errors };
      if (!this.state.residentialStatus) errors.residentialStatus = "Residential status is required";
      if (!this.state.perm_line || !this.state.perm_line.trim()) errors.perm_line = "Address line is required";
      if (!this.state.perm_city || !this.state.perm_city.trim()) errors.perm_city = "City is required";
      if (!this.state.perm_state || !this.state.perm_state.trim()) errors.perm_state = "State is required";
      if (!this.state.perm_pin || !this.state.perm_pin.trim()) errors.perm_pin = "PIN Code is required";
      this.setState({ errors }, () => {
        const firstError = document.querySelector('.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return;
    }

    if (this.validateForm()) {
      const permAddressStr = serializeAddress({
        line: this.state.perm_line,
        city: this.state.perm_city,
        district: this.state.perm_district,
        state: this.state.perm_state,
        pin: this.state.perm_pin
      });
      
      const commAddressStr = this.state.sameAddress === "yes" ? permAddressStr : serializeAddress({
        line: this.state.comm_line,
        city: this.state.comm_city,
        district: this.state.comm_district,
        state: this.state.comm_state,
        pin: this.state.comm_pin
      });

      console.info("Valid Form");

      let reqParam = {
        residentialStatus: this.state.residentialStatus,
        permanentAddress: permAddressStr,
        communicationAddress: commAddressStr,
        same_address: this.state.sameAddress
      };
      let updateProfile = await updateSignApplication(reqParam);

      // Trigger KRA registration upload in background/fallback flow
      try {
        await uploadKraDetails({
          app_cor_add1: this.state.comm_line,
          app_cor_city: this.state.comm_city,
          app_cor_state: this.state.comm_state,
          app_cor_pincode: this.state.comm_pin,
          app_per_add1: this.state.perm_line,
          app_per_city: this.state.perm_city,
          app_per_state: this.state.perm_state,
          app_per_pincode: this.state.perm_pin,
          app_pan_copy: "N",
          app_exmt_id_proof: "02"
        });
      } catch (err) {
        console.warn("KRA Upload notification fallback error:", err);
      }

      this.renderRedirect();
    } else {
      console.error("Invalid Form");
    }
  };
  render() {
    const { errors } = this.state;
    return (      <div className="col-md-6 col-lg-5 col-xl-4">

      <div className="container my-auto py-4 bg-white shadow-lg rounded">
        <div className="row mt-2">
          <div className="col-11 col-lg-11 mx-auto">
            <h1>Address Details</h1>

            <form id="registerForm" className="form-border" method="post">
              <div className="form-group icon-group floating-label-wrap">
              

<select
                  id="residentialStatus"
                  className="form-control  floating-label-field floating-label-field--s1"
                  onChange={this.handleChange}
                  onBlur={this.handleChange}
                  noValidate
                  value={this.state.residentialStatus}
                > <option value="">Select an option</option>

                  <option value="Resident Individual">Resident Individual</option>
                  <option value="Non Resident Indian">Non Resident Indian</option>
                  <option value="Foreign National">Foreign National</option>
                  <option value="Person of Indian Origin">Person of Indian Origin</option>
                </select>

                 <label className="floating-label">Residential Status</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-address-card"></i>
                </span>   {errors.residentialStatus && errors.residentialStatus.length > 0 && (
                  <span className="error">{errors.residentialStatus}</span>
                )}

              </div>

              <h5 className="mt-4 mb-3" style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>Permanent Address</h5>
              
              <div className="form-group icon-group floating-label-wrap">
                <input 
                  type="text"
                  className="form-control floating-label-field floating-label-field--s1"
                  id="perm_line"
                  required
                  placeholder="House No, Street, Locality"
                  onChange={this.handleChange}
                  value={this.state.perm_line}
                />
                <label className="floating-label">House No, Street, Locality</label>
                <span className="icon-inside text-primary">
                  <i className="fas fa-home"></i>
                </span>
                {errors.perm_line && errors.perm_line.length > 0 && (
                  <span className="error">{errors.perm_line}</span>
                )}
              </div>

              <div className="row">
                <div className="col-6 pr-1">
                  <div className="form-group icon-group floating-label-wrap">
                    <input 
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="perm_city"
                      required
                      placeholder="City"
                      onChange={this.handleChange}
                      value={this.state.perm_city}
                    />
                    <label className="floating-label">City</label>
                    {errors.perm_city && errors.perm_city.length > 0 && (
                      <span className="error">{errors.perm_city}</span>
                    )}
                  </div>
                </div>
                <div className="col-6 pl-1" style={{ display: 'none' }}>
                  <div className="form-group icon-group floating-label-wrap">
                    <input 
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="perm_district"
                      placeholder="District"
                      onChange={this.handleChange}
                      value={this.state.perm_district}
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-6 pr-1">
                  <div className="form-group icon-group floating-label-wrap">
                    <input 
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="perm_state"
                      required
                      placeholder="State"
                      onChange={this.handleChange}
                      value={this.state.perm_state}
                    />
                    <label className="floating-label">State</label>
                    {errors.perm_state && errors.perm_state.length > 0 && (
                      <span className="error">{errors.perm_state}</span>
                    )}
                  </div>
                </div>
                <div className="col-6 pl-1">
                  <div className="form-group icon-group floating-label-wrap">
                    <input 
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="perm_pin"
                      required
                      placeholder="PIN Code"
                      onChange={this.handleChange}
                      value={this.state.perm_pin}
                    />
                    <label className="floating-label">PIN Code</label>
                    {errors.perm_pin && errors.perm_pin.length > 0 && (
                      <span className="error">{errors.perm_pin}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="form-group form-check text-left pl-0 my-3" style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  id="sameAddress"
                  style={{ width: "20px", height: "20px", marginRight: "10px", cursor: "pointer" }}
                  checked={this.state.sameAddress === "yes"}
                  onChange={this.handleSameAddressChange}
                />
                <label className="form-check-label text-2 text-muted mb-0" htmlFor="sameAddress" style={{ cursor: "pointer" }}>
                  Communication Address same as Permanent Address
                </label>
              </div>

              {this.state.sameAddress !== "yes" && (
                <div>
                  <h5 className="mt-4 mb-3" style={{ fontSize: '16px', fontWeight: 'bold', color: '#333' }}>Communication Address</h5>
                  
                  <div className="form-group icon-group floating-label-wrap">
                    <input 
                      type="text"
                      className="form-control floating-label-field floating-label-field--s1"
                      id="comm_line"
                      required
                      placeholder="House No, Street, Locality"
                      onChange={this.handleChange}
                      value={this.state.comm_line}
                    />
                    <label className="floating-label">House No, Street, Locality</label>
                    <span className="icon-inside text-primary">
                      <i className="fas fa-home"></i>
                    </span>
                  </div>

                  <div className="row">
                    <div className="col-6 pr-1">
                      <div className="form-group icon-group floating-label-wrap">
                        <input 
                          type="text"
                          className="form-control floating-label-field floating-label-field--s1"
                          id="comm_city"
                          required
                          placeholder="City"
                          onChange={this.handleChange}
                          value={this.state.comm_city}
                        />
                        <label className="floating-label">City</label>
                      </div>
                    </div>
                    <div className="col-6 pl-1" style={{ display: 'none' }}>
                      <div className="form-group icon-group floating-label-wrap">
                        <input 
                          type="text"
                          className="form-control floating-label-field floating-label-field--s1"
                          id="comm_district"
                          placeholder="District"
                          onChange={this.handleChange}
                          value={this.state.comm_district}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-6 pr-1">
                      <div className="form-group icon-group floating-label-wrap">
                        <input 
                          type="text"
                          className="form-control floating-label-field floating-label-field--s1"
                          id="comm_state"
                          required
                          placeholder="State"
                          onChange={this.handleChange}
                          value={this.state.comm_state}
                        />
                        <label className="floating-label">State</label>
                      </div>
                    </div>
                    <div className="col-6 pl-1">
                      <div className="form-group icon-group floating-label-wrap">
                        <input 
                          type="text"
                          className="form-control floating-label-field floating-label-field--s1"
                          id="comm_pin"
                          required
                          placeholder="PIN Code"
                          onChange={this.handleChange}
                          value={this.state.comm_pin}
                        />
                        <label className="floating-label">PIN Code</label>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <button
                className="btn btn-primary btn-block text-uppercase mt-4"
                type="button"
                onClick={this.handleSubmit}
              >
                NEXT
              </button>
            </form>
          </div>
        </div>
      </div><Footer /></div>
    );
  }
}
export default withRouter(AddressDetails);